import React from 'react';
import PaymentButton from './PaymentButton';

function Razorpay({handleSubmit, module='', Amount=0, Value}) {
  return (
      <PaymentButton handleSubmit={handleSubmit} module={module} Amount={Amount} Value={Value} />
  );
}

export default Razorpay;